var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2771 17.8034H14.4841H15.9563C16.3661 17.8034 16.7592 17.9662 17.049 18.256C17.3388 18.5459 17.5016 18.9389 17.5016 19.3488V27.7246C17.5016 28.1345 17.6644 28.5276 17.9543 28.8174C18.2441 29.1072 18.6371 29.27 19.047 29.27H26.8814C27.2597 29.27 27.6308 29.1672 27.9551 28.9726C28.5836 28.5955 28.9682 27.9162 28.9682 27.1832V9.51924C28.9682 9.10972 28.8607 8.70737 28.6564 8.35242C28.4649 8.01963 28.1944 7.73911 27.8688 7.53561L17.1054 0.808521C16.5702 0.473965 15.9741 0.248334 15.3515 0.144559L15.2444 0.126715C14.7417 0.0429361 14.228 0.0512197 13.7283 0.151162C13.2304 0.250732 12.7547 0.439633 12.3242 0.708719L1.24472 7.63339C1.01969 7.77404 0.817075 7.9477 0.643666 8.14857C0.22845 8.62955 0 9.24377 0 9.87918L0 27.7246C0 28.1345 0.162815 28.5276 0.452628 28.8174C0.742441 29.1072 1.13551 29.27 1.54537 29.27H9.92121C10.3311 29.27 10.7241 29.1072 11.014 28.8174C11.3038 28.5276 11.4666 28.1345 11.4666 27.7246V19.6139C11.4666 19.0441 11.7349 18.5074 12.1908 18.1655C12.5042 17.9305 12.8854 17.8034 13.2771 17.8034Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c01dd787e158c32132fb6996f128d091.svg";
export { ForwardRef as ReactComponent };